/* Alfie: Lazyload fallback - Vanilla JS */

// Get browser name and version
function get_browser() {
  var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
  if(/trident/i.test(M[1])){
    tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
    return {name:'IE',version:(tem[1]||'')};
  }   
  if(M[1]==='Chrome'){
    tem=ua.match(/\bOPR|Edge\/(\d+)/)
    if(tem!=null)   {return {name:'Opera', version:tem[1]};}
  }   
  M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
  if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
  return {
    name: M[0],
    version: M[1]
  };
}

var browser=get_browser(); 
// browser.name = 'Chrome'
// browser.version = '90'

//console.log(browser);

// Get parameter function
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

var lazyfallback = getUrlParameter('lazyfallback');

//console.log(lazyfallback);
// On document load or on scroll load the lazyLoad fallback function
if (browser.name == "Safari" && (browser.version == "13" || browser.version == "14")  && lazyfallback == "true") {
//if (browser.name == "Chrome" && lazyfallback == "true") {
  window.addEventListener("scroll", function() { lazyLoadVanillaJS() });
  window.addEventListener("DOMContentLoaded", function() { lazyLoadVanillaJS() });
}

function lazyLoadVanillaJS() {
  var images = document.querySelectorAll('.lazyload');
  for (var i=0, nb=images.length ; i <nb ; i++) {
    var img = images[i]
    var rect = img.getBoundingClientRect();
    var isVisible = ((rect.top - window.innerHeight) < 200 && (rect.bottom) > -50 ) ? true : false ;

    if (isVisible) {
      if (!img.src) {
        //img.src = img.dataset.src;
        img.src = img.dataset.srcset;
        img.style.border = "2px solid #ff0000";
      }
    }
  }
  //console.log('Lazy Load Fallback Loaded');
}